import React, { useState } from 'react';
import { Grid, Typography, Card, CardContent, Box, DialogTitle, Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { FaArrowUp } from "react-icons/fa";
import { GetVoidSeguimientoDTO, SeguimientoDTO } from '../../types/Seguimiento/SeguimientoDTO';
import { MdModeEdit } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

interface TimelineProps {
    eventos: SeguimientoDTO[];
    edit?: boolean;
}

const Timeline: React.FC<TimelineProps> = ({ eventos, edit = false }) => {
    const [open, setOpen] = useState(false);
    const [selectedEvento, setSelectedEvento] = useState<SeguimientoDTO>(GetVoidSeguimientoDTO());
    const navigate = useNavigate();
    // funciones
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const selectEvento = (eve: SeguimientoDTO) => {
        if (eve.bdEstado === 'R') {
            setSelectedEvento(eve);
            handleClickOpen();
        }
    }
    const estado = (estado: string) => {
        let texto = ''
        switch (estado) {
            case 'P':
                texto = 'Enviado'
                break;
            case 'A':
                texto = 'Aprobado'
                break;
            case 'R':
                texto = 'Rechazado'
                break;
            case 'U':
                texto = 'Publicado'
                break;
            case 'E':
                texto = 'Expirado'
                break;
            default:
                break;
        }
        return texto
    }
    return (
        <Grid container spacing={4} justifyContent="center" sx={{ position: 'relative' }}>
            {eventos.map((evento, index) => (
                <Grid
                    container
                    item
                    xs={12}
                    key={evento.idSecuencia}
                    sx={{ position: 'relative', display: 'flex' }}
                >
                    {/* Línea vertical de la línea de tiempo */}
                    <Grid item xs={1} sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                        <Box
                            sx={{
                                position: 'absolute',
                                top: 0,
                                bottom: 0,
                                width: '2px',
                                backgroundColor: '#3f51b5',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                        />
                        {/* Punto de conexión */}
                        <FaArrowUp
                            style={{ color: '#3f51b5', position: 'relative', zIndex: 2 }}
                        />
                    </Grid>

                    {/* Contenido del evento */}
                    <Grid item xs={11} onClick={() => selectEvento(evento)}>
                        <Card
                            sx={{
                                position: 'relative',
                                margin: '0 10px',
                                boxShadow: 3,
                                backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                                border: evento.bdEstado === 'R' ? `2px solid #C91616` : `2px solid #1976d2`,
                            }}
                        >
                            <CardContent>
                                <Typography
                                    variant="h1"
                                    component="div"
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        color: '#e0e0e0',
                                        fontSize: '5rem',
                                        fontWeight: 'bold',
                                        zIndex: 0,
                                        pointerEvents: 'none',
                                        opacity: 0.2,
                                    }}
                                >
                                    {new Date(evento.dtSeguimiento).getFullYear()}
                                </Typography>
                                <Box position="relative" zIndex={1}>
                                    <Typography variant="h5" gutterBottom>
                                        {estado(evento.bdEstado)}
                                    </Typography>
                                    <Typography variant="caption" color="primary">
                                        Fecha: {new Date(evento.dtSeguimiento).toLocaleString()}
                                    </Typography>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            ))}
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="sm" // Cambia a 'xs', 'sm', 'lg', etc.
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    Comentario
                </DialogTitle>
                <DialogContent>
                    {selectedEvento.txObservacion}
                </DialogContent>
                {edit ?
                    <DialogActions>
                        <Button variant='contained' onClick={() => navigate(`/creator/editanuncio/${selectedEvento.idAnuncio}`)} endIcon={<MdModeEdit />}>
                            Editar
                        </Button>
                    </DialogActions> : <></>}
            </Dialog>
        </Grid>
    );
};

export default Timeline;